<template>
  <section>
    <div class="modal-body">
      <form action="" class="m-form m-form--state">
        <div  class="m-portlet__body">
          <div class="m-form__group form-group" :class="{'has-danger': errors.has('property_name')}">
            <label>{{'property_name' | translate | capitalize}}</label>
            <input v-validate="'required|min:3'" type="text" name="property_name" class="form-control m-input" v-model="property.name">
            <span v-show="errors.has('property_name')" class="m-form__help m--font-danger">{{ errors.first('property_name') }}</span>
          </div>
          <div class="m-form__group form-group row" >
            <div :class="[{'has-danger': errors.has('database_name')}, 'col-lg-6']">
              <label>{{'database_name' | translate | capitalize}}</label>
              <input v-validate="'required|uniqueDatabase'" type="text" name="database_name" class="form-control m-input" @keyup="formatDatabaseName" v-model="property.database">
              <span v-show="errors.has('database_name')" class="m-form__help m--font-danger">{{ errors.first('database_name') }}</span>
            </div>
            <div :class="[{'has-danger': errors.has('email')}, 'col-lg-6']">
              <label for="email">{{'manager_email' | translate | capitalize }}</label>
              <input type="text" id="email" v-model="property.email" name="email" class="form-control m-input" v-validate="'required|email'">
              <span v-show="errors.has('email')" class="m-form__help m--font-danger"> {{errors.first('email')}} </span>
            </div>
          </div>
          <div class="m-form__group form-group row">
            <div class="col-lg-6" :class="{'has-danger': errors.has('shard')}">
              <label>{{'shard' | translate | capitalize}}</label>
              <input v-validate="'required'" type="text" name="shard" class="form-control m-input" @keyup="formatShardName" v-model="property.shard">
              <span v-show="errors.has('shard')" class="m-form__help m--font-danger">{{ errors.first('shard') }}</span>
            </div>
            <div class="col-lg-6" :class="{'has-danger': errors.has('database_user')}">
              <label>{{'database_user' | translate | capitalize}}</label>
              <input v-validate="'required'" type="text" name="database_user" class="form-control m-input" v-model="property.username">
              <span v-show="errors.has('database_user')" class="m-form__help m--font-danger">{{ errors.first('database_user') }}</span>           
            </div>
          </div>
          <div class="m-form__group form-group row">
            <div class="col-lg-6" :class="{'has-danger': errors.has('database_user')}">
              <label>{{'password' | translate | capitalize}}</label>
              <input v-validate="'required|confirmed:password'" type="password" name="password" class="form-control m-input" v-model="property.password">
              <span v-show="errors.has('password')" class="m-form__help m--font-danger">{{ errors.first('password') }}</span>
            </div>
            <div class="col-lg-6" :class="{'has-danger': errors.has('confirm_password')}">
              <label>{{'confirm_password' | translate | capitalize}}</label>
              <input v-validate="'required|confirmed:password'" type="password" name="confirm_password" class="form-control m-input" v-model="repassword">
              <span v-show="errors.has('confirm_password')" class="m-form__help m--font-danger">{{ errors.first('confirm_password') }}</span>           
            </div>
          </div>
          <div class="m-form__group form-group row">
            <div class="col-lg-6" :class="{'has-danger': errors.has('country')}">
              <label>{{'country' | translate | capitalize}}</label>
              <select  v-validate="'required'" v-model="property.country" name="country" class="form-control m-input" >
                <option value="">
                  {{'select_country' | translate | capitalize}}
                </option>  
                <option v-for="(option,index) in countries" :key="index" :value="option.name">
                  {{option.key | translate | capitalize}}
                </option>                    
              </select>
              <span v-show="errors.has('country')" class="m-form__help m--font-danger">{{ errors.first('country') }}</span>           
            </div>
            <div class="col-lg-6" :class="{'has-danger': errors.has('timezone')}">
              <label>{{'time_zone' | translate | capitalize}}</label>
              <select  v-validate="'required'" v-model="property.timezone" name="timezone" class="form-control m-input" >
                <option value="">
                  {{'select_timezone' | translate | capitalize}}
                </option>  
                <option v-for="(option,index) in timezones" :key="index" :value="option.name">
                  {{option.key | translate | capitalize}}
                </option>                    
              </select>
              <span v-show="errors.has('timezone')" class="m-form__help m--font-danger">{{ errors.first('timezone') }}</span>           
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button"  class="btn btn-secondary" data-dismiss="modal" @click="back">
        {{'cancel' | translate | capitalize}}
      </button>
      <button type="submit" class="btn btn-primary" @click="validateForm" >
        {{'create' | translate | capitalize}}
      </button>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { Validator } from 'vee-validate'
  import service from '@/services/superaccess'
  export default {
    data () {
      return {
        property: {
          name: '',
          database: '',
          host: 'localhost',
          shard: '',
          username: '',
          timezone: '',
          country: '',
          password: '',
          port: '5432',
          adapter: 'postgresql',
          state: 'creating'
        },
        repassword: '',
        countries: [],
        timezones: []
      }
    },
    computed: {
      ...mapGetters({modal: 'getStatusSupModal'})
    },
    created () {
      this.uniqueDatabase()
      this.getCountries().then((result) => {
        this.countries = result.data.content.countries
        this.timezones = result.data.content.timezones
      })
    },
    methods: {
      ...mapActions(['createProperty', 'getCountries', 'changeStatusSupModal']),
      formatDatabaseName () {
        this.property.database = this.property.database.toLowerCase().replace(/ /g, '_')
      },
      formatShardName () {
        this.property.shard = this.property.shard.toLowerCase().replace(/ /g, '_')
      },
      uniqueDatabase () {
        const uniqueDatabase = (value) => {
          return service.post('/api/properties/check-database', this.$store, { database: value, id: this.property.id ? this.property.id : '' })
            .then((response) => {
              return {
                valid: response.data.valid,
                data: {
                  message: this.$options.filters.capitalize('database_already_exists')
                }
              }
            })
        }
        Validator.extend('uniqueDatabase', {
          validate: uniqueDatabase,
          getMessage: (field, params, data) => {
            return data.message
          }
        })
      },
      back () {
        this.property = {
          name: '',
          database: '',
          host: 'localhost',
          shard: '',
          username: '',
          timezone: '',
          country: '',
          password: '',
          port: '5432',
          adapter: 'postgresql',
          state: 'creating'
        }
        this.changeStatusSupModal(false)
        this.$validator.reset()
      },
      validateForm () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$spinner.show()
            this.createProperty(this.property).then((result) => {
              this.$spinner.remove()
              if (result.status === 200) {
                this.$toast('create_property_message')
                window.$('.modal-backdrop').remove()
                this.$router.push({name: 'select-property'})
              } else {
                this.$toast('create_property_error', 4)
              }
            })
          }
        })
      }
    },
    watch: {
      modal () {
        this.$validator.reset()
      }
    }
  }
</script>

<style scoped>
  .m-portlet__body {
    padding-bottom: 8px !important;
  }
  .m-widget4__item {
    border-bottom: 0.15rem solid #ebedf2 !important;
  }

  #container-no-data {
    text-align: center;
  }

  #container-no-data > i {
    font-size: 150px !important;
  }

  #container-no-data > p {
    font-size: 50px !important;
  }
</style>


// WEBPACK FOOTER //
// NewProperty.vue